

import { ref, defineComponent } from 'vue'
import type { PropType } from 'vue'
import { bytesToSize, isTruePlayFormat } from '@remote/utils'
import { IconClose } from '@xunlei/thunder-icon-vue'
import { IShowTrees } from '@remote/type/index'
import FileInfo from '@remote/components/FileInfo.vue'
import VirtualList from '@remote/components/VirtualList.vue'
import { store } from '@remote/store'
import { isMobile, isLargeViewPort } from '@remote/utils/base'
import throttle from 'lodash/throttle'
import { usePathSelector, checkDiskAbnormal } from '@remote/store/hezi-file/path-selector'
import { safeJSONParse } from '@shared/utils'
import DownloadPath from './DownloadPath.vue'
import { toast } from '@remote/utils/dialog'
import Loading from '@remote/components/Loading.vue'
import { ITreedTorrentNode } from '@remote/api/adapter/type'

export default defineComponent({
  name: 'BtChoicePop',
  components: {
    FileInfo,
    VirtualList,
    IconClose,
    DownloadPath,
    Loading,
  },
  props: {
    btTree: {
      type: [Array, Promise] as PropType<ITreedTorrentNode[] | Promise<ITreedTorrentNode[]>>,
      default: () => [],
    },
    linkStatus: {
      type: Object,
      default: () => ({}),
    },
    offset: {
      type: Number,
      default: 0,
    },
    id: {
      type: String,
      default: '',
    },
    isLimitDownloaded: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['on-close', 'on-ok', 'on-floatup'],
  setup (props) {
    let retreat
    let loading
    console.log('setup', props.btTree)
    const { toggleVisibleSelectFolder, selectedPath, checkFileExit } = usePathSelector()
    if (props.btTree instanceof Promise) {
      loading = ref(true)
      retreat = ref([])
    } else {
      loading = ref(false)
      retreat = ref(props.btTree)
    }

    return {
      loading,
      retreat,
      store,
      toggleVisibleSelectFolder,
      selectedPath,
      checkFileExit,
      isLargeViewPort: isLargeViewPort(),
    }
  },
  data () {
    return {
      chooseAll: false, // 是否全选
      chooseIds: [],
      onlyVideo: false,
      allNodeList: [],
      allIndex: [],
      videoIndex: [],
      showTrees: {
        checkType: 0,
        title: '',
        icon: '',
        file_index: 0,
        file_size: '',
        isDir: false,
        id: '',
        children: [],
      },
      backIndex: [],
      treeIndex: 0,
      showIndexTree: false,
      isEmpty: false,
      selectAll: false,

      dragging: false,
      currentY: 0,
      currentX: 0,
      prevY: 0,
      prevX: 0,
      startX: 0,
      startY: 0,
      lastPath: null,
      dataMap: new Map(),
      downloadedNums: 0,
    } as {
      chooseAll: boolean
      chooseIds: string[]
      onlyVideo: boolean
      allNodeList: IShowTrees[]
      dataMap: Map<string, IShowTrees>
      allIndex: string[]
      videoIndex: string[]
      showTrees: IShowTrees
      backIndex: number[]
      treeIndex: number
      showIndexTree: boolean
      isEmpty: boolean
      dragging: boolean
      currentY: number
      currentX: number
      prevY: number
      prevX: number
      startX: number
      startY: number
      lastPath: null | {}
      downloadedNums: number
    }
  },
  computed: {
    diskLeftSize () {
      return this.selectedPath.value.free
    },
    belowMinimum () {
      return this.selectedPath.value.free <= 10 * 1024
    },
    shortDownloadPath (): string {
      if (!this.selectedPath && !this.lastPath) return ''

      const showPath = this.lastPath?.displayPath || this.selectedPath.value?.displayPath

      let pathArr = showPath.split(' > ')

      if (pathArr.length <= 3) pathArr = pathArr.map((item) => {
        return item.length > 5 ? `${item.substring(0, 4)}...` : item
      })

      if (pathArr.length > 3) {
        return [
          pathArr[0],
          pathArr[1],
          '...',
          pathArr[pathArr.length - 1],
        ].join(' > ')
      }
      return showPath
    },
    back () {
      return this.backIndex.length > 0 || (this.showIndexTree && this.retreat.length > 1)
    },
    showDownload () {
      return this.isLargeViewPort ? true : (
        (this.backIndex.length === 0 && this.retreat.length === 1) ||
        (!this.showIndexTree && this.retreat.length > 1)
      )
    },
    footerFrameStyle () {
      return isMobile() ? {} : { right: '4px' || `${this.currentX + this.offset}px`, top: `${- this.offset - this.currentY}px` }
    },
    submitFrameStyle () {
      return isMobile() ? {} : { right: `${this.currentX + this.offset}px`, bottom: `calc(20% + ${(this.offset + this.currentY) / 2}px)` }
    },
    selectedFilesSize () {
      return bytesToSize(this.chooseIds.reduce((total, item) => {
        return this.dataMap.get(item).size + total
      }, 0))
    },
  },
  // watch: {
  //   retreat () {
  //     this.init()
  //   },
  // },
  created () {
    this.onDraggingThrottle = throttle(this.onDragging, 16)
  },
  async mounted () {
    console.log('mounted', this.retreat, this.loading, this.isLimitDownloaded)
    if (this.loading) {
      try {
        const btTree = await this.btTree
        this.retreat = btTree
        this.loading = false
        console.log('mounted', btTree)
      } catch (err) {
        console.log('continu add error', err)
        this.$emit('on-close')
        toast({ type: 'error', message: err || '链接继续添加失败' })
        return
      }
    }

    this.init()
    const task = this.store?.state.all[this.id]
    if (this.store?.state.tasks.includes(this.id) && task) {
      const extData = safeJSONParse(task.ext_data) as { dir: string }
      this.lastPath = await this.checkFileExit(extData.dir)
    } else {
      this.checkFileExit()
    }
  },
  unmounted () {
    this.dataIdMap = null
    this.chooseIdsMap = null
  },
  methods: {
    onDragStart (e) {
      if (isMobile()) return
      e.preventDefault()
      this.dragging = true
      this.startX = e.clientX
      this.startY = e.clientY

      window.addEventListener('mousemove', this.onDraggingThrottle)
      window.addEventListener('mouseup', this.onDragEnd)
      window.addEventListener('contextmenu', this.onDragEnd)
    },
    onDragging (e) {
      e.preventDefault()
      if (this.dragging) {
        this.currentX = this.startX - e.clientX + this.prevX
        this.currentY = this.startY - e.clientY + this.prevY
      }
    },
    onDragEnd () {
      this.dragging = false
      this.prevX = this.currentX
      this.prevY = this.currentY
      window.removeEventListener('mousemove', this.onDraggingThrottle)
      window.removeEventListener('mouseup', this.onDragEnd)
      window.removeEventListener('contextmenu', this.onDragEnd)
    },
    bytesToSize,
    handleTaskTree (files, index) {
      console.log('files', files, 'index', index)
      this.treeIndex = index
      this.showTrees = this.retreat[this.treeIndex]
      this.showIndexTree = true
    },
    handleGetIn (files, index) {
      this.backIndex.push(index)
      let showTrees = this.retreat[this.treeIndex]
      for (let i = 0; i < this.backIndex.length; i++) {
        showTrees = showTrees.children[this.backIndex[i]]
      }
      this.showTrees = showTrees
    },
    getUpperPath () {
      console.log('this.backIndex', this.backIndex.length)
      if (this.backIndex.length > 0) {
        this.backIndex.pop()
        let showTrees = this.retreat[this.treeIndex]
        for (let i = 0; i < this.backIndex.length; i++) {
          showTrees = showTrees.children[this.backIndex[i]]
        }
        this.showTrees = showTrees
      } else if (this.showIndexTree) {
        // this.showIndexTree = false
      }
    },
    goFileIndex () {
      if (this.retreat.length <= 1) {
        this.showIndexTree = true
      } else {
        this.showIndexTree = false
      }
      this.showTrees = this.retreat[this.treeIndex]
      this.backIndex = []
    },
    async showVisiblePathChoose () {
      this.toggleVisibleSelectFolder(true)
    },
    handleClose () {
      this.$emit('on-close')
    },
    async handleSubmit () {
      const isDiskAbnormal = await checkDiskAbnormal(this.selectedPath.value.path)
      if (isDiskAbnormal) {
        toast({ type: 'error', message: '当前位置磁盘容量不足' })
        return false
      }

      if (this.chooseIds.length <= 0) {
        toast({ type: 'warn', message: '未添加下载任务' })
        return false
      }
      let list: IShowTrees
      if (this.chooseAll) {
        list = this.allNodeList.slice()
      } else {
        list = this.chooseIds.map((item) => {
          return this.dataMap.get(item)
        })
      }

      this.$emit('on-ok', list, this.selectedPath.value.path, this.retreat[0]?.title)
    },
    handleSelectVideo () {
      if (this.onlyVideo) {
        this.checkTree(this.retreat, this.videoIndex, 0)
      } else {
        this.checkTree(this.retreat, this.allIndex, 0)
        this.checkTree(this.retreat, this.videoIndex, 1)
      }
      // this.initShowTrees()
      this.checkChooseAllAndSetCheckType()
    },
    checkCheckType (source: IShowTrees[], parent: IShowTrees | undefined) {
      let select = 0
      let unselect = 0
      source.forEach((el) => {
        el.children && el.children.length > 0 ? this.checkCheckType(el.children, el) : ''
        // @ts-ignore
        if (el.checkType === 1 || el.is_download && this.isLimitDownloaded) {
          select++
        } else if (el.checkType === 0) {
          unselect++
        }
      })
      parent &&
        (parent.checkType = source.length === select ? 1 : source.length === unselect ? 0 : 2)
    },
    checkChooseAllAndSetCheckType () {
      if (this.chooseIds.length === this.allIndex.length) {
        this.chooseAll = true
      } else {
        this.chooseAll = false
      }
      if (
        this.videoIndex &&
        this.videoIndex.sort().toString() === this.chooseIds.sort().toString()
      ) {
        this.onlyVideo = true
      } else {
        this.onlyVideo = false
      }
      this.checkCheckType(this.retreat, undefined)
    },
    handleChooseAll () {
      const startTime = Date.now()
      if (this.chooseAll) {
        const values = Array.from(this.dataMap.values()) as IShowTrees[]
        for (let el of values) {
          el.checkType = 0
        }
        this.chooseIds = []
        this.chooseIdsMap = {}
      } else {
        const values = Array.from(this.dataMap.values()) as IShowTrees[]
        for (let el of values) {
          // @ts-ignore
          if (el.is_download && this.isLimitDownloaded) continue
          el.checkType = 1
          this.chooseIdsMap[el.id] = 1
          // this.chooseIds.push(el.id)
        }
        this.chooseIds = this.allIndex.slice()
      }
      console.log('handleChooseAll calc:', Date.now() - startTime)
      this.checkChooseAllAndSetCheckType()
    },
    getTree (source, list, isInit = false, parentIds = [], rootEle = {}) {
      let allFileInTheDirectoryDownloaded = true
      let partFileInTheDirectoryDownloaded = false
      source.forEach((el) => {
        if (!el.isDir) {
          list.push(el)
          if (isInit) {
            const fileDownloaded = el.is_download && this.isLimitDownloaded
            if (fileDownloaded) {
              // 只要有一个下载就是部分下载
              partFileInTheDirectoryDownloaded = true
              this.downloadedNums += 1
            } else {
              // 只要有一个未下载就是非全部下载
              allFileInTheDirectoryDownloaded = false
              this.allIndex.push(el.id)
              if (isTruePlayFormat(el.title)) this.videoIndex.push(el.id)
            }

            if (parentIds.length) {
              parentIds.forEach(pid => {
                if (this.dataIdMap[pid] && Array.isArray(this.dataIdMap[pid])) {
                  this.dataIdMap[pid].push(el.id)
                } else {
                  this.dataIdMap[pid] = [el.id]
                }
              })
            }
            this.dataMap.set(el.id, el)
          }
        }
        if (el.children && el.children.length > 0) {
          if (isInit) {
            this.dataIdMap[el.id] = []
          }
          this.getTree(el.children, list, isInit, [...parentIds, el.id], el)
        }
      })
      // 修改目录的选中态
      if (isInit) {
        if (allFileInTheDirectoryDownloaded) {
          // @ts-ignore
          rootEle.is_download = true
        } else if (partFileInTheDirectoryDownloaded) {
          // @ts-ignore
          rootEle.checkType = 3
        }
      }
    },
    handleFile (file, index) {
      if (file.isDir) {
        const indexList = this.dataIdMap[file.id]
        const checkType = file.checkType === 1 ? 0 : 1
        const map = {}
        for (let id of indexList) {
          if (map[id]) continue
          const el = this.dataMap.get(id)
          if (el && !el.isDir) {
            map[id] = 1
            el.checkType = checkType
            if (checkType === 0) {
              delete this.chooseIdsMap[id]
            } else {
              this.chooseIdsMap[id] = 1
            }
          }
        }
        file.checkType = checkType
      } else {
        const file = this.showIndexTree ? this.showTrees.children[index] : this.retreat[index]
        if (file.checkType === 1) {
          file.checkType = 0
          delete this.chooseIdsMap[file.id]
        } else {
          this.chooseIdsMap[file.id] = 1
          file.checkType = 1
        }
      }
      this.chooseIds = Object.keys(this.chooseIdsMap)
      this.checkChooseAllAndSetCheckType()
    },
    checkTree (source: IShowTrees[], list: string[], type: number) {
      const startTime = Date.now()
      for (let id of list) {
        const el = this.dataMap.get(id)
        if (type === 1) {
          this.chooseIdsMap[el.id] = 1
          el.checkType = 1
        } else {
          el.checkType = 0
          delete this.chooseIdsMap[el.id]
        }
      }
      this.chooseIds = Object.keys(this.chooseIdsMap)
      console.log('checkTree calc:', Date.now() - startTime)
    },
    getAllNodeIndex () {
      this.allIndex = this.allNodeList.map((item) => item.id)
    },
    getvideoNodeIndex () {
      this.handleSelectVideo()
    },
    init () {
      this.dataIdMap = {}
      this.chooseIdsMap = {}
      if (this.retreat.length === 1) {
        this.showIndexTree = true
      }
      this.showTrees = this.retreat[this.treeIndex]
      this.getTree(this.retreat, this.allNodeList, true)
      this.getvideoNodeIndex()
    },
    handleOnToastLimitDownloaded () {
      toast({ type: 'warn', message: '进行中状态，添加不支持修改位置' })
    },
  },
})
